var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsuranceModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25684 2.29792C7.73366 2.10719 8.26634 2.10719 8.74316 2.29792L12.1553 3.66218C12.6653 3.86641 12.9998 4.3608 13 4.91023V6.3907C12.9999 9.2504 11.4991 11.9008 9.04688 13.3721C8.40251 13.7585 7.59749 13.7585 6.95312 13.3721C4.50093 11.9008 3.00013 9.2504 3 6.3907V4.91023C3.00018 4.3608 3.33467 3.86641 3.84473 3.66218L7.25684 2.29792ZM8 7.50007C7.44646 7.50007 6.91584 7.71098 6.52441 8.08601C6.29893 8.30207 6.12975 8.56242 6.02734 8.84577C5.90186 9.19356 6.22428 9.50002 6.6084 9.50007H9.3916C9.77572 9.50002 10.0981 9.19356 9.97266 8.84577C9.87025 8.56242 9.70107 8.30207 9.47559 8.08601C9.08416 7.71098 8.55354 7.50007 8 7.50007ZM8 5.50007C7.44772 5.50007 7 5.94779 7 6.50007C7.00003 7.05233 7.44773 7.50007 8 7.50007C8.55227 7.50007 8.99997 7.05233 9 6.50007C9 5.94779 8.55228 5.50007 8 5.50007Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsuranceModule);
export default __webpack_public_path__ + "static/media/Insurance_module.c8a4be5fdad6b20bba10206425cdda8f.svg";
export { ForwardRef as ReactComponent };